/**
 * Timezones list
 *
 * @see https://github.com/omsrivastava/timezones-list/blob/master/dist/timezones.json
 *
 * The mentioned hours are not reliable for checks as they are not the same as the UTC offset.
 * For example, the UTC offset for America/New_York is -04:00, but the hours are 05:00 as daylight saving time.
 */
export const TIMEZONES = [
  {
    label: "America/Adak (GMT-10:00)",
    tzCode: "America/Adak",
    name: "(GMT-10:00) Adak, Atka, Nikolski, Unalaska, Saint Paul",
    utc: "-10:00",
    abbr: "HST",
    fullZoneName: "Hawaii Standard Time",
  },
  {
    label: "America/Anchorage (GMT-09:00)",
    tzCode: "America/Anchorage",
    name: "(GMT-09:00) Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview",
    utc: "-09:00",
    abbr: "AKST",
    fullZoneName: "Alaska Standard Time",
  },
  {
    label: "America/Belize (GMT-06:00)",
    tzCode: "America/Belize",
    name: "(GMT-06:00) Belize City, San Ignacio, Orange Walk, Belmopan, Dangriga",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Boise (GMT-07:00)",
    tzCode: "America/Boise",
    name: "(GMT-07:00) Boise, Meridian, Nampa, Idaho Falls, Pocatello",
    utc: "-07:00",
    abbr: "MST",
    fullZoneName: "Mountain Standard Time",
  },
  {
    label: "America/Chicago (GMT-06:00)",
    tzCode: "America/Chicago",
    name: "(GMT-06:00) Chicago, Houston, San Antonio, Dallas, Austin",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Costa_Rica (GMT-06:00)",
    tzCode: "America/Costa_Rica",
    name: "(GMT-06:00) San José, Puerto Limón, San Francisco, Alajuela, Liberia",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Denver (GMT-07:00)",
    tzCode: "America/Denver",
    name: "(GMT-07:00) Denver, El Paso, Albuquerque, Colorado Springs, Aurora",
    utc: "-07:00",
    abbr: "MST",
    fullZoneName: "Mountain Standard Time",
  },
  {
    label: "America/Detroit (GMT-05:00)",
    tzCode: "America/Detroit",
    name: "(GMT-05:00) Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor",
    utc: "-05:00",
    abbr: "EST",
    fullZoneName: "Eastern Standard Time",
  },
  {
    label: "America/El_Salvador (GMT-06:00)",
    tzCode: "America/El_Salvador",
    name: "(GMT-06:00) San Salvador, Soyapango, Santa Ana, San Miguel, Mejicanos",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Guatemala (GMT-06:00)",
    tzCode: "America/Guatemala",
    name: "(GMT-06:00) Guatemala City, Mixco, Villa Nueva, Petapa, San Juan Sacatepéquez",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Halifax (GMT-04:00)",
    tzCode: "America/Halifax",
    name: "(GMT-04:00) Halifax, Dartmouth, Sydney, Glace Bay, Moncton",
    utc: "-04:00",
    abbr: "AST",
    fullZoneName: "Atlantic Standard Time",
  },
  {
    label: "America/Indianapolis (GMT-05:00)",
    tzCode: "America/Indianapolis",
    name: "(GMT-05:00) Indianapolis, Fort Wayne, Evansville, South Bend, Carmel",
    utc: "-05:00",
    abbr: "EST",
    fullZoneName: "Eastern Standard Time",
  },
  {
    label: "America/Jamaica (GMT-05:00)",
    tzCode: "America/Jamaica",
    name: "(GMT-05:00) Kingston, New Kingston, Spanish Town, Portmore, Montego Bay",
    utc: "-05:00",
    abbr: "EST",
    fullZoneName: "Eastern Standard Time",
  },
  {
    label: "America/Los_Angeles (GMT-08:00)",
    tzCode: "America/Los_Angeles",
    name: "(GMT-08:00) Los Angeles, San Diego, San Jose, San Francisco, Seattle",
    utc: "-08:00",
    abbr: "PST",
    fullZoneName: "Pacific Standard Time",
  },
  {
    label: "America/Managua (GMT-06:00)",
    tzCode: "America/Managua",
    name: "(GMT-06:00) Managua, León, Masaya, Chinandega, Matagalpa",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Mexico_City (GMT-06:00)",
    tzCode: "America/Mexico_City",
    name: "(GMT-06:00) Mexico City, Iztapalapa, Ecatepec, Guadalajara, Puebla",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/New_York (GMT-05:00)",
    tzCode: "America/New_York",
    name: "(GMT-05:00) New York City, Brooklyn, Queens, Philadelphia, Manhattan",
    utc: "-05:00",
    abbr: "EST",
    fullZoneName: "Eastern Standard Time",
  },
  {
    label: "America/Panama (GMT-05:00)",
    tzCode: "America/Panama",
    name: "(GMT-05:00) Panama City, San Miguelito, Juan Díaz, David, Arraiján",
    utc: "-05:00",
    abbr: "EST",
    fullZoneName: "Eastern Standard Time",
  },
  {
    label: "America/Phoenix (GMT-07:00)",
    tzCode: "America/Phoenix",
    name: "(GMT-07:00) Phoenix, Tucson, Mesa, Chandler, Gilbert",
    utc: "-07:00",
    abbr: "MST",
    fullZoneName: "Mountain Standard Time",
  },
  {
    label: "America/Puerto_Rico (GMT-04:00)",
    tzCode: "America/Puerto_Rico",
    name: "(GMT-04:00) San Juan, Bayamón, Carolina, Ponce, Caguas",
    utc: "-04:00",
    abbr: "AST",
    fullZoneName: "Atlantic Standard Time",
  },
  {
    label: "America/Regina (GMT-06:00)",
    tzCode: "America/Regina",
    name: "(GMT-06:00) Regina, Saskatoon, Prince Albert, Moose Jaw, Swift Current",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Tegucigalpa (GMT-06:00)",
    tzCode: "America/Tegucigalpa",
    name: "(GMT-06:00) Tegucigalpa, San Pedro Sula, Choloma, La Ceiba, El Progreso",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "America/Toronto (GMT-05:00)",
    tzCode: "America/Toronto",
    name: "(GMT-05:00) Toronto, Montreal, Ottawa, Mississauga, Brampton",
    utc: "-05:00",
    abbr: "EST",
    fullZoneName: "Eastern Standard Time",
  },
  {
    label: "America/Vancouver (GMT-08:00)",
    tzCode: "America/Vancouver",
    name: "(GMT-08:00) Vancouver, Surrey, Burnaby, Richmond, Abbotsford",
    utc: "-08:00",
    abbr: "PST",
    fullZoneName: "Pacific Standard Time",
  },
  {
    label: "America/Winnipeg (GMT-06:00)",
    tzCode: "America/Winnipeg",
    name: "(GMT-06:00) Winnipeg, Brandon, Steinbach, Thompson, Portage la Prairie",
    utc: "-06:00",
    abbr: "CST",
    fullZoneName: "Central Standard Time",
  },
  {
    label: "Pacific/Honolulu (GMT-10:00)",
    tzCode: "Pacific/Honolulu",
    name: "(GMT-10:00) Honolulu, East Honolulu, Pearl City, Hilo, Kailua",
    utc: "-10:00",
    abbr: "HST",
    fullZoneName: "Hawaii Standard Time",
  },
];

export const TIMEZONES_MAP_BY_TZ_CODE = TIMEZONES.reduce(
  (acc, timezone) => {
    acc[timezone.tzCode] = timezone;
    return acc;
  },
  {} as Record<string, (typeof TIMEZONES)[number]>
);

/**
 * Canonical zone for each US timezone label offered in booking dropdowns.
 *
 * `fullZoneName` in TIMEZONES above is NOT unique (e.g. America/Belize and
 * America/Chicago are both "Central Standard Time" but Belize never observes
 * DST), so resolving a zone by label lookup over that array picks an
 * arbitrary region and corrupts times during daylight saving (GLE-8091).
 * Datetime construction must go through this map instead.
 */
export const US_ZONE_NAME_TO_TZ_CODE = {
  "Eastern Standard Time": "America/New_York",
  "Central Standard Time": "America/Chicago",
  "Mountain Standard Time": "America/Denver",
  "Arizona Time": "America/Phoenix",
  "Pacific Standard Time": "America/Los_Angeles",
  "Alaska Standard Time": "America/Anchorage",
  "Hawaii Standard Time": "Pacific/Honolulu",
} as const;

export type UsZoneName = keyof typeof US_ZONE_NAME_TO_TZ_CODE;

/**
 * Daylight saving time timezones
 */
export const DST_TIMEZONES = [
  {
    label: "America/Adak (GMT-09:00)",
    tzCode: "America/Adak",
    name: "(GMT-09:00) Adak, Atka, Nikolski, Unalaska, Saint Paul",
    utc: "-09:00",
    abbr: "HDT",
    fullZoneName: "Hawaii Daylight Time",
  },
  {
    label: "America/Anchorage (GMT-08:00)",
    tzCode: "America/Anchorage",
    name: "(GMT-08:00) Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview",
    utc: "-08:00",
    abbr: "AKDT",
    fullZoneName: "Alaska Daylight Time",
  },
  {
    label: "America/Boise (GMT-06:00)",
    tzCode: "America/Boise",
    name: "(GMT-06:00) Boise, Meridian, Nampa, Idaho Falls, Pocatello",
    utc: "-06:00",
    abbr: "MDT",
    fullZoneName: "Mountain Daylight Time",
  },
  {
    label: "America/Chicago (GMT-05:00)",
    tzCode: "America/Chicago",
    name: "(GMT-05:00) Chicago, Houston, San Antonio, Dallas, Austin",
    utc: "-05:00",
    abbr: "CDT",
    fullZoneName: "Central Daylight Time",
  },
  {
    label: "America/Denver (GMT-06:00)",
    tzCode: "America/Denver",
    name: "(GMT-06:00) Denver, El Paso, Albuquerque, Colorado Springs, Aurora",
    utc: "-06:00",
    abbr: "MDT",
    fullZoneName: "Mountain Daylight Time",
  },
  {
    label: "America/Detroit (GMT-04:00)",
    tzCode: "America/Detroit",
    name: "(GMT-04:00) Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor",
    utc: "-04:00",
    abbr: "EDT",
    fullZoneName: "Eastern Daylight Time",
  },
  {
    label: "America/Halifax (GMT-03:00)",
    tzCode: "America/Halifax",
    name: "(GMT-03:00) Halifax, Dartmouth, Sydney, Glace Bay, Moncton",
    utc: "-03:00",
    abbr: "ADT",
    fullZoneName: "Atlantic Daylight Time",
  },
  {
    label: "America/Indianapolis (GMT-04:00)",
    tzCode: "America/Indianapolis",
    name: "(GMT-04:00) Indianapolis, Fort Wayne, Evansville, South Bend, Carmel",
    utc: "-04:00",
    abbr: "EDT",
    fullZoneName: "Eastern Daylight Time",
  },
  {
    label: "America/Los_Angeles (GMT-07:00)",
    tzCode: "America/Los_Angeles",
    name: "(GMT-07:00) Los Angeles, San Diego, San Jose, San Francisco, Seattle",
    utc: "-07:00",
    abbr: "PDT",
    fullZoneName: "Pacific Daylight Time",
  },
  {
    label: "America/New_York (GMT-04:00)",
    tzCode: "America/New_York",
    name: "(GMT-04:00) New York City, Brooklyn, Queens, Philadelphia, Manhattan",
    utc: "-04:00",
    abbr: "EDT",
    fullZoneName: "Eastern Daylight Time",
  },
  {
    label: "America/Toronto (GMT-04:00)",
    tzCode: "America/Toronto",
    name: "(GMT-04:00) Toronto, Montreal, Ottawa, Mississauga, Brampton",
    utc: "-04:00",
    abbr: "EDT",
    fullZoneName: "Eastern Daylight Time",
  },
  {
    label: "America/Vancouver (GMT-07:00)",
    tzCode: "America/Vancouver",
    name: "(GMT-07:00) Vancouver, Surrey, Burnaby, Richmond, Abbotsford",
    utc: "-07:00",
    abbr: "PDT",
    fullZoneName: "Pacific Daylight Time",
  },
  {
    label: "America/Winnipeg (GMT-05:00)",
    tzCode: "America/Winnipeg",
    name: "(GMT-05:00) Winnipeg, Brandon, Steinbach, Thompson, Portage la Prairie",
    utc: "-05:00",
    abbr: "CDT",
    fullZoneName: "Central Daylight Time",
  },
];
